/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type HumanityAnalyticsTopVcIssuerRequest = {
    period?: HumanityAnalyticsTopVcIssuerRequest.period;
};

export namespace HumanityAnalyticsTopVcIssuerRequest {

    export enum period {
        D7 = 'D7',
        D30 = 'D30',
        D90 = 'D90',
        ALL = 'ALL',
    }


}

